export default "__VITE_ASSET__DOECGtcp__"